<section class="about-hero">
  <img class="about-hero__img" src="assets/images/hero-generated.png" alt="" />
  <div class="about-hero__shade" aria-hidden="true"></div>

  <div class="container about-hero__content">
    <div class="about__card glass">
      <h1 class="about__title">{{ 'about.title' | translate }}</h1>

      <p class="about__lead">{{ 'about.p1' | translate }}</p>
      <p class="about__para">{{ 'about.p2' | translate }}</p>
      <p class="about__para">{{ 'about.p3' | translate }}</p>
      <p class="about__seo">{{ 'about.seoLine' | translate }}</p>
    </div>
  </div>
</section>

